import React from 'react';
import Header from '../components/Common/Header';
import './LegalPages.css';

const Terms = () => {
  return (
    <>
      <Header />
      <div className="legal-page">
        <div className="legal-container">
          <h1>Terms of Service</h1>

          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using the Bihar Election Tracker application ("Service"), you accept and agree to be bound by 
              the terms and provisions of this agreement. This Service is operated by Bihar Election (a private entity) and 
              is not affiliated with any government organization or official election commission.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Description of Service</h2>
            <p>
              Bihar Election Tracker is a privately operated information platform that provides:
            </p>
            <ul>
              <li>Election-related news and updates</li>
              <li>Candidate information and profiles</li>
              <li>Vote counting results and analysis</li>
              <li>Voter awareness content</li>
              <li>Poll percentage tracking</li>
              <li>Survey and opinion polls</li>
            </ul>
            <p>
              All information provided is for educational and informational purposes only. We are not an official 
              government agency and do not conduct or oversee actual elections.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. User Eligibility</h2>
            <p>
              You must be at least 18 years old to use this Service. By using this Service, you represent and warrant 
              that you meet this age requirement and have the legal capacity to enter into these Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. User Accounts</h2>
            <p>
              Some features of the Service may require you to create an account. You are responsible for:
            </p>
            <ul>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized access</li>
              <li>Providing accurate and up-to-date information</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. User Conduct</h2>
            <p>You agree NOT to use the Service to:</p>
            <ul>
              <li>Violate any local, state, national, or international law</li>
              <li>Post false, misleading, or defamatory content</li>
              <li>Impersonate any person or entity</li>
              <li>Interfere with or disrupt the Service or servers</li>
              <li>Collect or store personal data about other users</li>
              <li>Upload viruses or malicious code</li>
              <li>Engage in any form of harassment or hate speech</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Intellectual Property</h2>
            <p>
              The Service and its original content, features, and functionality are owned by Bihar Election and are 
              protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Third-Party Content</h2>
            <p>
              Our Service may contain links to third-party websites or services that are not owned or controlled by 
              Bihar Election. We have no control over and assume no responsibility for the content, privacy policies, 
              or practices of any third-party websites or services.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Disclaimer of Warranties</h2>
            <p>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Limitation of Liability</h2>
            <p>
              Bihar Election shall not be liable for any indirect, incidental, special, consequential, or punitive damages 
              resulting from your use of or inability to use the Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Modifications to Service</h2>
            <p>
              We reserve the right to modify, suspend, or discontinue the Service (or any part thereof) at any time 
              without notice.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will notify users of any material changes by 
              posting the new Terms on this page.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of India.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us:
            </p>
            <ul>
              <li>Email: contact@bihar.com.co</li>
              <li>Phone: +91 7482909107</li>
              <li>Address: Patna, Bihar 800001, India</li>
            </ul>
          </section>
        </div>
      </div>
    </>
  );
};

export default Terms;
